/*
* StatisticsTrendsCards.jsx
* Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
* All rights reserved.
*/
import { Card, CardContent, CardHeader, Divider } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import "../ApplicationStatistics.css";

const getValidNumber = (value) => (Number.isNaN(value) ? 0 : value);

export const StatisticsTrendsCards = ({ statisticsTotalData }) => {
  const [totalInstallCurrentCount, settotalInstallCurrentCount] = useState(0);
  const [totalInstallLastCount, settotalInstallLastCount] = useState(0);
  const [totalInstallTrends, setTotalInstallTrends] = useState("");
  const [totalInstallPercentage, setTotalInstallPercentage] = useState(0);

  const [activeDevicesCurrentCount, setActiveDevicesCurrentCount] = useState(0);
  const [activeDevicesLastCount, setActiveDevicesLastCount] = useState(0);
  const [activeDevicesTrends, setActiveDevicesTrends] = useState("");
  const [activeDevicesPercentage, setActiveDevicesPercentage] = useState(0);

  const [activeSessionsCurrentCount, setActiveSessionsCurrentCount] =
    useState(0);
  const [activeSessionsLastCount, setActiveSessionsLastCount] = useState(0);
  const [activeSessionsTrends, setActiveSessionsTrends] = useState("");
  const [activeSessionsPercentage, setActiveSessionsPercentage] = useState(0);

  const [activePerDeviceCurrentCount, setActivePerDeviceCurrentCount] =
    useState(0);
  const [activePerDeviceLastCount, setActivePerDeviceLastCount] = useState(0);
  const [activePerDeviceTrends, setActivePerDeviceTrends] = useState("");
  const [activePerDevicePercentage, setActivePerDevicePercentage] = useState(0);

  useEffect(() => {
    if (statisticsTotalData?.totalInstalls) {
      const totalInstallData = statisticsTotalData.totalInstalls;

      settotalInstallCurrentCount(totalInstallData.currentCount);
      settotalInstallLastCount(totalInstallData.lastCount);
      setTotalInstallTrends(totalInstallData.trendingDeatil.trend);
      setTotalInstallPercentage(totalInstallData.trendingDeatil.percentage);
    }

    if (statisticsTotalData?.activeDevices) {
      const activeDevicesData = statisticsTotalData.activeDevices;

      setActiveDevicesCurrentCount(activeDevicesData.currentCount);
      setActiveDevicesLastCount(activeDevicesData.periodicCount);
      setActiveDevicesTrends(activeDevicesData.trendingDeatil.trend);
      setActiveDevicesPercentage(activeDevicesData.trendingDeatil.percentage);
    }

    if (statisticsTotalData?.activeSessions) {
      const activeSessionsData = statisticsTotalData.activeSessions;

      setActiveSessionsCurrentCount(getValidNumber(activeSessionsData.currentCount));
      setActiveSessionsLastCount(getValidNumber(activeSessionsData.periodicCount));
      setActiveSessionsTrends(activeSessionsData.trendingDeatil.trend);
      setActiveSessionsPercentage(activeSessionsData.trendingDeatil.percentage);
    }

    if (statisticsTotalData?.activeSessionsPerDevice) {
      const activeSessionsPerDeviceData =
        statisticsTotalData.activeSessionsPerDevice;

      setActivePerDeviceCurrentCount(
        getValidNumber(activeSessionsPerDeviceData.currentCount)
      );
      setActivePerDeviceLastCount(
        Number.isNaN(activeSessionsPerDeviceData.lastCount)
          ? 0
          : activeSessionsPerDeviceData.periodicCount
      );
      setActivePerDeviceTrends(
        activeSessionsPerDeviceData.trendingDeatil.trend
      );
      setActivePerDevicePercentage(
        activeSessionsPerDeviceData.trendingDeatil.percentage
      );
    }
  }, [statisticsTotalData]);

  return (
    <div className="cardCls" id="dashboardCls">
      <Card
        sx={{
          height: 145,
          boxShadow: "none",
          border: "1px solid #12141533"
        }}
      >
        <CardHeader
          action={
            <>
              {totalInstallTrends === "DOWN" && (
                <span className="CardHeaderDownCls">
                  <ArrowDownwardIcon className="arrowIconCls" />
                  <span className="percentageDownCls">
                    {totalInstallPercentage}%
                  </span>
                </span>
              )}
              {totalInstallTrends === "UP" && (
                <span className="CardHeaderUpCls">
                  <ArrowUpwardIcon className="arrowIconCls" />
                  <span className="percentageUpCls">
                    {totalInstallPercentage}%
                  </span>
                </span>
              )}
            </>
          }
          title="Total Installs"
          disableTypography
        />
        <Divider sx={{marginTop: "0px !important"}} />
        <CardContent sx={{ textAlign: "center" }}>
          <span className="currentCountCls">{totalInstallCurrentCount}</span>
          <p className="lastCountCls">{totalInstallLastCount}</p>
        </CardContent>
      </Card>
      <Card
        sx={{
          height: 145,
          boxShadow: "none",
          border: "1px solid #12141533",
        }}
      >
        <CardHeader
          action={
            <>
              {activeDevicesTrends === "DOWN" && (
                <span className="CardHeaderDownCls">
                  <ArrowDownwardIcon className="arrowIconCls" />
                  <span className="percentageDownCls">
                    {activeDevicesPercentage}%
                  </span>
                </span>
              )}
              {activeDevicesTrends === "UP" && (
                <span className="CardHeaderUpCls">
                  <ArrowUpwardIcon className="arrowIconCls" />
                  <span className="percentageUpCls">
                    {activeDevicesPercentage}%
                  </span>
                </span>
              )}
            </>
          }
          title="Active Devices"
          disableTypography
        />
        <Divider sx={{marginTop: "0px !important"}} />
        <CardContent sx={{ textAlign: "center" }}>
          <span className="currentCountCls">{activeDevicesCurrentCount}</span>
          <p className="lastCountCls">{activeDevicesLastCount}</p>
        </CardContent>
      </Card>
      <Card
        sx={{
          height: 145,
          boxShadow: "none",
          border: "1px solid #12141533",
        }}
      >
        <CardHeader
          action={
            <>
              {activeSessionsTrends === "DOWN" && (
                <span className="CardHeaderDownCls">
                  <ArrowDownwardIcon className="arrowIconCls" />
                  <span className="percentageDownCls">
                    {activeSessionsPercentage}%
                  </span>
                </span>
              )}
              {activeSessionsTrends === "UP" && (
                <span className="CardHeaderUpCls">
                  <ArrowUpwardIcon className="arrowIconCls" />
                  <span className="percentageUpCls">
                    {activeSessionsPercentage}%
                  </span>
                </span>
              )}
            </>
          }
          title="Active Sessions"
          disableTypography
        />
        <Divider sx={{marginTop: "0px !important"}} />
        <CardContent sx={{ textAlign: "center" }}>
          <span className="currentCountCls">{activeSessionsCurrentCount}</span>
          <p className="lastCountCls">{activeSessionsLastCount}</p>
        </CardContent>
      </Card>
      <Card
        sx={{
          height: 145,
          boxShadow: "none",
          border: "1px solid #12141533",
        }}
      >
        <CardHeader
          sx={{ padding: "7px" }}
          action={
            <>
              {activePerDeviceTrends === "DOWN" && (
                <span className="CardHeaderDownCls activeSessionPerDeviceCls">
                  <ArrowDownwardIcon className="arrowIconCls" />
                  <span className="percentageDownCls ">
                    {activePerDevicePercentage}%
                  </span>
                </span>
              )}
              {activePerDeviceTrends === "UP" && (
                <span className="CardHeaderUpCls activeSessionPerDeviceCls">
                  <ArrowUpwardIcon className="arrowIconCls" />
                  <span className="percentageUpCls ">
                    {activePerDevicePercentage}%
                  </span>
                </span>
              )}
            </>
          }
          title="Active sessions Per Device"
          disableTypography
        />
        <Divider sx={{marginTop: "0px !important"}} />
        <CardContent sx={{ textAlign: "center" }}>
          <span className="currentCountCls">{activePerDeviceCurrentCount}</span>
          <p className="lastCountCls">{activePerDeviceLastCount}</p>
        </CardContent>
      </Card>
    </div>
  );
};

StatisticsTrendsCards.propTypes = {
  statisticsTotalData: PropTypes.shape({
    totalInstalls: PropTypes.shape({
      currentCount: PropTypes.number,
      lastCount: PropTypes.number,
      trendingDeatil: PropTypes.shape({
        trend: PropTypes.string,
        percentage: PropTypes.number,
      }),
    }),
    activeDevices: PropTypes.shape({
      currentCount: PropTypes.number,
      periodicCount: PropTypes.number,
      trendingDeatil: PropTypes.shape({
        trend: PropTypes.string,
        percentage: PropTypes.number,
      }),
    }),
    activeSessions: PropTypes.shape({
      currentCount: PropTypes.number,
      periodicCount: PropTypes.number,
      trendingDeatil: PropTypes.shape({
        trend: PropTypes.string,
        percentage: PropTypes.number,
      }),
    }),
    activeSessionsPerDevice: PropTypes.shape({
      currentCount: PropTypes.number,
      lastCount: PropTypes.number,
      periodicCount: PropTypes.number,
      trendingDeatil: PropTypes.shape({
        trend: PropTypes.string,
        percentage: PropTypes.number,
      }),
    }),
  }),
};
